/* eslint-disable max-len */
import { Stack, Title } from '@mantine/core';
import { defineMessages, useIntl } from 'react-intl';

import styles from './TeamMemberParents.module.scss';

import MothersDetails from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/Components/TeamMemberParents/Components/MothersDetails/MothersDetails';
import { useTeamMemberContext } from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/TeamMemberDetailsContext';
import FathersDetails from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/Components/TeamMemberParents/Components/FathersDetails/FathersDetails';

const headingId = 'team-member-parents-heading';

const TeamMemberParents = () => {
    const intl = useIntl();
    const { values } = useTeamMemberContext();
    const hasParentsData = values.parents?.length;

    if (!hasParentsData) {
        return null;
    }

    return (
        <Stack gap="sm" aria-labelledby={headingId}>
            <Title order={3} size="h4" id={headingId} className={styles.heading}>{intl.formatMessage(messages.heading)}</Title>
            <MothersDetails />
            <FathersDetails />
        </Stack>
    );
};

const basePath = 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.Details.Components.TeamMemberParents.TeamMemberParents';

const messages = defineMessages({
    heading: {
        id: `${basePath}.heading`,
        defaultMessage: 'Dane rodziców',
    },
});

export default TeamMemberParents;
